import React from 'react';
import { CrownIcon, RocketIcon, MailIcon, PhoneIcon, CalendarIcon } from 'lucide-react';
const Slide5 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2750">
      <div className="flex flex-col space-y-6" data-id="element-2751">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-6" data-id="element-2752">
          Business model & next steps
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-2753">
          {/* Left Column - Business Model */}
          <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200" data-id="element-2754">
            <h3 className="text-xl font-semibold text-indigo-800 mb-4" data-id="element-2755">
              Business Model
            </h3>
            <div className="space-y-4" data-id="element-2756">
              <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-2757">
                <h4 className="font-medium text-gray-800 mb-2" data-id="element-2758">
                  SaaS + performance
                </h4>
                <p className="text-sm text-gray-600" data-id="element-2759">
                  Base subscription fee plus performance-based pricing tied to
                  usage and uplift metrics.
                </p>
              </div>
              <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-2760">
                <h4 className="font-medium text-gray-800 mb-2" data-id="element-2761">
                  Pilot then expand
                </h4>
                <p className="text-sm text-gray-600" data-id="element-2762">
                  Start with a focused pilot across Sonae MC, then expand to
                  additional brands and channels.
                </p>
              </div>
              <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-2763">
                <h4 className="font-medium text-gray-800 mb-2" data-id="element-2764">
                  Key Performance Indicators
                </h4>
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-2765">
                  <li className="flex items-center gap-2" data-id="element-2766">
                    <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2767"></div>
                    <span data-id="element-2768">Conversion uplift</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-2769">
                    <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2770"></div>
                    <span data-id="element-2771">Average Order Value (AOV)</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-2772">
                    <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2773"></div>
                    <span data-id="element-2774">Attach rate</span>
                  </li>
                  <li className="flex items-center gap-2" data-id="element-2775">
                    <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2776"></div>
                    <span data-id="element-2777">Assisted revenue</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* Crown Visualization - Simplified */}
            <div className="flex justify-center mt-6" data-id="element-2778">
              <div className="bg-amber-50 rounded-lg p-4 border border-amber-200 text-center" data-id="element-2779">
                <CrownIcon className="h-8 w-8 text-amber-500 mx-auto mb-2" data-id="element-2780" />
                <p className="text-amber-800 font-medium" data-id="element-2781">
                  Now is the time to act — the one who adopts wins the crown.
                </p>
              </div>
            </div>
          </div>
          {/* Right Column - CTA */}
          <div className="bg-blue-50 rounded-lg p-6 border border-blue-200 flex flex-col justify-between" data-id="element-2782">
            <div data-id="element-2783">
              <h3 className="text-xl font-semibold text-blue-800 mb-4" data-id="element-2784">
                Implementation Timeline
              </h3>
              <div className="space-y-3 mb-6" data-id="element-2785">
                <div className="flex items-center gap-3" data-id="element-2786">
                  <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0" data-id="element-2787">
                    1
                  </div>
                  <div data-id="element-2788">
                    <h4 className="font-medium text-gray-800" data-id="element-2789">
                      Discovery & Setup
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-2790">2 weeks</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-2791">
                  <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0" data-id="element-2792">
                    2
                  </div>
                  <div data-id="element-2793">
                    <h4 className="font-medium text-gray-800" data-id="element-2794">Pilot Launch</h4>
                    <p className="text-sm text-gray-600" data-id="element-2795">1 month</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-2796">
                  <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0" data-id="element-2797">
                    3
                  </div>
                  <div data-id="element-2798">
                    <h4 className="font-medium text-gray-800" data-id="element-2799">Optimization</h4>
                    <p className="text-sm text-gray-600" data-id="element-2800">Ongoing</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-2801">
                  <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0" data-id="element-2802">
                    4
                  </div>
                  <div data-id="element-2803">
                    <h4 className="font-medium text-gray-800" data-id="element-2804">Full Rollout</h4>
                    <p className="text-sm text-gray-600" data-id="element-2805">
                      Based on pilot results
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Big CTA */}
            <div className="mt-auto" data-id="element-2806">
              <div className="bg-indigo-600 rounded-lg p-6 text-center text-white" data-id="element-2807">
                <h3 className="text-2xl font-bold mb-3" data-id="element-2808">
                  Are you ready to get your Pilot?
                </h3>
                <p className="text-lg mb-4" data-id="element-2809">ShoPilots.com</p>
                {/* Book a Meeting Button */}
                <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3d8hIh-SBmquhBLzT0K2NNUsyp9W7OJz3kZC5dS4y2t7kSLPqcz7Ll5kRBTrX_hUBi2XAKTHHq" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-white text-indigo-700 px-6 py-3 rounded-lg hover:bg-indigo-50 transition-colors font-bold mb-4 mx-auto" data-id="element-2810">
                  <CalendarIcon className="h-5 w-5" data-id="element-2811" />
                  <span data-id="element-2812">Book a Meeting</span>
                </a>
                <div className="flex flex-col sm:flex-row justify-center gap-3 mt-4" data-id="element-2813">
                  <a href="mailto:ben@shopilots.com" className="flex items-center justify-center gap-2 bg-white text-indigo-700 px-4 py-2 rounded-lg hover:bg-indigo-50 transition-colors" data-id="element-2814">
                    <MailIcon className="h-5 w-5" data-id="element-2815" />
                    <span data-id="element-2816">ben@shopilots.com</span>
                  </a>
                  <a href="tel:+972505450460" className="flex items-center justify-center gap-2 bg-white text-indigo-700 px-4 py-2 rounded-lg hover:bg-indigo-50 transition-colors" data-id="element-2817">
                    <PhoneIcon className="h-5 w-5" data-id="element-2818" />
                    <span data-id="element-2819">+972 50 545 0460</span>
                  </a>
                </div>
              </div>
              <div className="text-center mt-4" data-id="element-2820">
                <p className="text-gray-600" data-id="element-2821">Contact: Ben Geva</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide5;